module.exports = __webpack_public_path__ + "media/images/upload-file-outlined-7e50aa80.svg";